var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-item"},[_c('div',{staticClass:"cat-name"},[_vm._v("期刊分布")]),_c('div',{attrs:{"id":"chart-period"}})])
}]

export { render, staticRenderFns }